import { Box, Image, Text, Button, VStack, HStack, Heading, Icon, chakra, Skeleton, Flex } from '@chakra-ui/react';
import React, { useState } from 'react';
import Medico from '../../../../../../images/dashboard/consultorioMedico.png';
import Dentista from '../../../../../../images/dashboard/consultorioDentista.png';
import { useNavigate } from 'react-router-dom';
import useModelAtendimentoPresencial from './useModelAtendimentoPresencial';
import { IoMdCalendar } from 'react-icons/io';

export const AtendimentoPresencial = () => {
  const [imgLoaded, setImgLoaded] = useState({ medico1: false, medico2: false, dentista: false });
  const navigate = useNavigate();
  const { valores, error, loading } = useModelAtendimentoPresencial();
  return (
    <Flex w="100%" justify="center" mt={4} mb={2}>
      <Box border="1px solid #5AB2AE" borderRadius="1em" boxShadow="lg" p={4} w="96%" maxW="480px">
        <VStack w="100%" spacing={6}>
          <Box
            borderRadius="20px"
            w="100%"
            bg="white"
            p={4}
            border="1px solid"
            borderColor="gray.100"
            boxShadow="xl"
            display="flex"
            flexDirection="column"
            gap={4}
          >
            <HStack spacing={4} align="center" width="100%">
              <Box flexShrink={0} width="100px" height="100px" borderRadius="lg" overflow="hidden">
                <Skeleton isLoaded={imgLoaded.medico1}>
                  <Image
                    src={Medico}
                    alt="medico"
                    objectFit="cover"
                    w="100%"
                    h="100%"
                    onLoad={() => setImgLoaded((prev) => ({ ...prev, medico1: true }))}
                  />
                </Skeleton>
              </Box>

              <VStack width="100%" align="flex-start" spacing={0}>
                <Text fontSize="sm" color="#9E9E9E" noOfLines={1}>
                  Atendimento
                </Text>

                <Heading as="h3" size={{ base: 'md', sm: 'lg' }} color="#616161" fontWeight="extrabold" noOfLines={2} lineHeight="1.1" m={0} p={0}>
                  Consulta Presencial
                </Heading>

                <HStack w="100%" justifyContent="space-between" alignItems="flex-end" mt={1}>
                  <VStack align="flex-start" spacing={0} lineHeight="1">
                    {valores.valor_consulta && (
                      <Text fontSize="0.7em" color="#9E9E9E">
                        a partir de
                      </Text>
                    )}

                    {valores.valor_consulta !== null && !loading && (
                      <Text as="h3" color={!error ? '#9E9E9E' : 'red'} fontWeight="semibold">
                        {Number(valores?.valor_consulta || 0).toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                      </Text>
                    )}
                  </VStack>
                  {valores.valor_consulta !== null && (
                    <>
                      <Button
                        disabled={valores.valor_consulta === null || loading}
                        bg={valores.valor_consulta === null ? 'gray.300' : '#5AB2AE'}
                        color="white"
                        leftIcon={<Icon as={IoMdCalendar} boxSize={{ base: 4, sm: 5 }} />}
                        borderRadius="full"
                        fontSize="sm"
                        px={{ base: 4, sm: 5 }}
                        py={3}
                        w={{ base: '50%', sm: 'auto' }}
                        onClick={() =>
                          navigate('/medicosGeral', {
                            state: { typeList: 'Medicos' },
                          })
                        }
                      >
                        Agendar
                      </Button>
                    </>
                  )}
                </HStack>
                {valores.valor_consulta === null && !loading && (
                  <Text fontSize="0.7em" color="#757575" mt={2}>
                    Sem agendas disponíveis
                  </Text>
                )}
              </VStack>
            </HStack>
          </Box>

          <Box
            borderRadius="20px"
            w="100%"
            bg="white"
            p={4}
            border="1px solid"
            borderColor="gray.100"
            boxShadow="xl"
            display="flex"
            flexDirection="column"
            gap={4}
          >
            <HStack spacing={4} align="center" width="100%">
              <Box flexShrink={0} width="100px" height="100px" borderRadius="lg" overflow="hidden">
                <Skeleton isLoaded={imgLoaded.medico2}>
                  <Image
                    src={Medico}
                    alt="medico"
                    objectFit="cover"
                    w="100%"
                    h="100%"
                    onLoad={() => setImgLoaded((prev) => ({ ...prev, medico2: true }))}
                  />
                </Skeleton>
              </Box>

              <VStack width="100%" align="flex-start" spacing={0}>
                <Text fontSize="sm" color="#9E9E9E" noOfLines={1}>
                  Diagnóstico
                </Text>

                <Heading as="h3" size={{ base: 'md', sm: 'lg' }} color="#616161" fontWeight="extrabold" noOfLines={2} lineHeight="1.1" m={0} p={0}>
                  Exames
                </Heading>

                <HStack w="100%" justifyContent="space-between" alignItems="flex-end" mt={1}>
                  <VStack align="flex-start" spacing={0} lineHeight="1">
                    {valores.valor_exames && (
                      <Text fontSize="0.7em" color="#9E9E9E">
                        a partir de
                      </Text>
                    )}

                    {valores.valor_exames && !loading && (
                      <Text as="h3" color={!error ? '#9E9E9E' : 'red'} fontWeight="semibold">
                        {Number(valores?.valor_exames || 0).toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                      </Text>
                    )}
                  </VStack>
                  {valores.valor_exames && (
                    <>
                      <Button
                        bg={!valores.valor_exames ? 'gray.300' : '#5AB2AE'}
                        color="white"
                        leftIcon={<Icon as={IoMdCalendar} boxSize={{ base: 4, sm: 5 }} />}
                        borderRadius="full"
                        fontSize="sm"
                        px={{ base: 4, sm: 5 }}
                        py={3}
                        w={{ base: '50%', sm: 'auto' }}
                        onClick={() =>
                          navigate('/exames/agendamento', {
                            state: { grupo_nome: 'Exames', grupo: 0 },
                          })
                        }
                      >
                        Agendar
                      </Button>
                    </>
                  )}
                </HStack>
                {!valores.valor_exames && !loading && (
                  <Text fontSize="0.7em" color="#757575" mt={2}>
                    Sem agendas disponíveis
                  </Text>
                )}
              </VStack>
            </HStack>
          </Box>

          <Box
            borderRadius="20px"
            w="100%"
            bg="white"
            p={4}
            border="1px solid"
            borderColor="gray.100"
            boxShadow="xl"
            display="flex"
            flexDirection="column"
            gap={4}
          >
            <HStack spacing={4} align="center" width="100%">
              <Box flexShrink={0} width="100px" height="100px" borderRadius="lg" overflow="hidden">
                <Skeleton isLoaded={imgLoaded.dentista}>
                  <Image
                    src={Dentista}
                    alt="dentista"
                    objectFit="cover"
                    w="100%"
                    h="100%"
                    onLoad={() => setImgLoaded((prev) => ({ ...prev, dentista: true }))}
                  />
                </Skeleton>
              </Box>

              <VStack width="100%" align="flex-start" spacing={0}>
                <Text fontSize="sm" color="#9E9E9E" noOfLines={1}>
                  Odontologia
                </Text>

                <Heading as="h3" size={{ base: 'md', sm: 'lg' }} color="#616161" fontWeight="extrabold" noOfLines={2} lineHeight="1.1" m={0} p={0}>
                  Consulta Odontológica
                </Heading>

                <HStack w="100%" justifyContent="space-between" alignItems="flex-end" mt={1}>
                  <VStack align="flex-start" spacing={0} lineHeight="1">
                    {valores.valor_odonto && (
                      <Text fontSize="0.7em" color="#9E9E9E">
                        a partir de
                      </Text>
                    )}

                    {valores.valor_odonto && !loading && (
                      <Text as="h3" color={!error ? '#9E9E9E' : 'red'} fontWeight="semibold">
                        {Number(valores?.valor_odonto || 0).toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                      </Text>
                    )}
                  </VStack>
                  {valores.valor_odonto && (
                    <>
                      <Button
                        colorScheme="teal"
                        color="white"
                        leftIcon={<Icon as={IoMdCalendar} boxSize={{ base: 4, sm: 5 }} />}
                        borderRadius="full"
                        fontSize="sm"
                        px={{ base: 4, sm: 5 }}
                        py={3}
                        w={{ base: '50%', sm: 'auto' }}
                        disabled={!valores.valor_odonto || loading}
                        bg={!valores.valor_odonto ? 'gray.300' : '#5AB2AE'}
                        onClick={() =>
                          navigate('/medicosGeral', {
                            state: { typeList: 'Dentistas' },
                          })
                        }
                      >
                        Agendar
                      </Button>
                    </>
                  )}
                </HStack>
                {!valores.valor_odonto && !loading && (
                  <Text fontSize="0.7em" color="#757575" mt={2}>
                    Sem agendas disponíveis
                  </Text>
                )}
              </VStack>
            </HStack>
          </Box>
          <Box
            borderRadius="20px"
            w="100%"
            bg="white"
            p={4}
            border="1px solid"
            borderColor="gray.100"
            boxShadow="xl"
            display="flex"
            flexDirection="column"
            gap={4}
          >
            <HStack spacing={4} align="center" width="100%">
              <Box flexShrink={0} width="100px" height="100px" borderRadius="lg" overflow="hidden">
                <Skeleton isLoaded={imgLoaded.medico1}>
                  <Image
                    src={Medico}
                    alt="medico"
                    objectFit="cover"
                    w="100%"
                    h="100%"
                    onLoad={() => setImgLoaded((prev) => ({ ...prev, medico1: true }))}
                  />
                </Skeleton>
              </Box>

              <VStack width="100%" align="flex-start" spacing={0}>
                <Text fontSize="sm" color="#9E9E9E" noOfLines={1}>
                  Outros Atendimentos
                </Text>

                <Heading as="h3" size={{ base: 'md', sm: 'lg' }} color="#616161" fontWeight="extrabold" noOfLines={2} lineHeight="1.1" m={0} p={0}>
                  Consulta Presencial
                </Heading>

                <HStack w="100%" justifyContent="space-between" alignItems="flex-end" mt={1}>
                  <VStack align="flex-start" spacing={0} lineHeight="1">
                    {valores.valor_outros && (
                      <Text fontSize="0.7em" color="#9E9E9E">
                        a partir de
                      </Text>
                    )}

                    {valores.valor_outros !== null && !loading && (
                      <Text as="h3" color={!error ? '#9E9E9E' : 'red'} fontWeight="semibold">
                        {Number(valores?.valor_outros || 0).toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                      </Text>
                    )}
                  </VStack>
                  {valores.valor_outros !== null && (
                    <>
                      <Button
                        disabled={valores.valor_outros === null || loading}
                        bg={valores.valor_outros === null ? 'gray.300' : '#5AB2AE'}
                        color="white"
                        leftIcon={<Icon as={IoMdCalendar} boxSize={{ base: 4, sm: 5 }} />}
                        borderRadius="full"
                        fontSize="sm"
                        px={{ base: 4, sm: 5 }}
                        py={3}
                        w={{ base: '50%', sm: 'auto' }}
                        onClick={() =>
                          navigate('/medicosGeral', {
                            state: { typeList: 'Outros' },
                          })
                        }
                      >
                        Agendar
                      </Button>
                    </>
                  )}
                </HStack>
                {valores.valor_outros === null && !loading && (
                  <Text fontSize="0.7em" color="#757575" mt={2}>
                    Sem agendas disponíveis
                  </Text>
                )}
              </VStack>
            </HStack>
          </Box>
        </VStack>
      </Box>
    </Flex>
  );
};

export default AtendimentoPresencial;
